import { EVENT_ADD_ACTION_TYPE, EVENT_DELETE_ACTION_TYPE, EVENT_DETAIL_ACTION_TYPE, EVENT_LIST_ACTION_TYPE } from "../../utils/constants";
const initialState = [];
function eventReducer(state=initialState,action){
    const{type,payload}=action;

    switch(type){
        case EVENT_LIST_ACTION_TYPE:
            return [...state,payload];
        case EVENT_ADD_ACTION_TYPE:
            return [...state,payload];
        case EVENT_DETAIL_ACTION_TYPE:
            return [...state,payload];
        case EVENT_DELETE_ACTION_TYPE:
            return [...state,payload];   
        default:
            return state;
    }
}
export default eventReducer;